import { FunctionComponent } from 'react';
import styles from "./WaterbodiesCampaign.module.css";
import cn from 'classnames';
import SidebarLayout from '../../../../../component/common/Layout/SidebarLayout/SidebarLayout';
import TextHeader from '../../../../../component/common/TextHeader/TextHeader';
import WaterbodiesCampaignTable from './component/WaterbodiesCampaignTable/WaterbodiesCampaignTable';
import WaterbodiesCampaignCard from './component/WaterbodiesCampaignCard/WaterbodiesCampaignCard';
import WaterBodiesTarget from '../../../../../component/UI/WaterBodiesTarget/WaterBodiesTarget';
import SendWaterBodyUpdates from '../../../../../component/UI/SendWaterBodyUpdates/SendWaterBodyUpdates';
import SearchInput from '../../../../../component/common/SearchInput/SearchInput';
import FilterSelect, { ThemeType } from '../../../../../component/common/FilterSelect/FilterSelect';

const WaterbodiesCampaign: FunctionComponent = () => {

    return (
        <SidebarLayout>
            <div className={cn(styles.waterbodiesPage)}>
                <div className={styles.waterbodiesRowOne}>
                    <TextHeader 
                        title={'Water Bodies Campaign'} 
                        summary={"Manage water bodies and send targeted updates to anglers"}
                        className='mb-4'
                    />
                    <div className={styles.waterBodiesCards}>
                        <WaterbodiesCampaignCard className={styles.waterBodiesCard} />
                        <WaterbodiesCampaignCard className={styles.waterBodiesCard} />
                        <WaterbodiesCampaignCard className={styles.waterBodiesCard} />
                    </div>
                </div>
                <div className={styles.waterbodiesRowTwo}>
                    <TextHeader 
                        title={'Water Bodies Database'} 
                        summary={"Manage your water bodies and fish species data"}
                        className='mb-4'
                    />
                    <div className={styles.filterWrap}>
                        <div className={styles.fiterItems}>
                            <div className={cn(styles.filterItem, styles.selectWaterbodies)}>
                                <FilterSelect 
                                    options={[
                                        { value: "all", label: "All Waterbodies" },
                                        { value: "Waterbodies1", label: "Waterbodies" },
                                        { value: "Waterbodies2", label: "Waterbodies 2" },
                                        { value: "Waterbodies3", label: "Waterbodies 3" },
                                    ]} 
                                    onSelect={(value: string): void => {
                                        
                                    } } 
                                    placeholder={'Select Waterbodies'} 
                                />
                            </div>
                            <div className={cn(styles.filterItem, styles.targetCities)}>
                                <FilterSelect 
                                    options={[
                                        { value: "all", label: "All Target cities" },
                                        { value: "Targetcities1", label: "Target cities" },
                                        { value: "Targetcities2", label: "Target cities 2" },
                                        { value: "Targetcities3", label: "Target cities 3" },
                                    ]} 
                                    onSelect={(value: string): void => {

                                    } } 
                                    placeholder={'Select Target cities'} 
                                />
                            </div>
                            <div className={cn(styles.filterItem, styles.selectWaterbodies)}>
                                <FilterSelect 
                                    options={[
                                        { value: "all", label: "All target zones" },
                                        { value: "Selecttargetzones1", label: "Select target zones" },
                                        { value: "Selecttargetzones2", label: "Select target zones 2" },
                                        { value: "Selecttargetzones3", label: "Select target zones 3" },
                                    ]} 
                                    onSelect={(value: string): void => {

                                    } } 
                                    placeholder={'Select target zones'}
                                />
                            </div>
                            <div className={cn(styles.filterItem, styles.setCount)}>
                                <FilterSelect 
                                    options={[
                                        { value: "all", label: "All Set Count" },
                                        { value: "SetCount1", label: "Set Count" },
                                        { value: "SetCount2", label: "Set Count 2" },
                                        { value: "SetCount3", label: "Set Count 3" },
                                    ]} 
                                    onSelect={(value: string): void => {
                                        
                                    } } 
                                    placeholder={'Set Count'} 
                                    dropdownTheme={ThemeType.GREEN}
                                />
                            </div>
                        </div>
                        <div className={styles.filterSearch}>
                            <SearchInput 
                                placeholder='Search Fishinity Pro center database' 
                                className={cn(styles.dashboardSearch, 'mb-0')}
                            />
                        </div>
                    </div>
                    <WaterbodiesCampaignTable />
                </div>
                <div className={styles.waterbodiesRowThree}>
                    <WaterBodiesTarget 
                        lakeList={[
                            { name: "Crystal Lake", lat: 42.2411, lng: -88.3162 },
                            { name: "Fox Lake", lat: 42.4156, lng: -88.1837 },
                            { name: "Island Lake", lat: 42.2764, lng: -88.2059 },
                            { name: "Lake Geneva", lat: 42.5917, lng: -88.4334 },
                            { name: "Bang’s Lake", lat: 42.2656, lng: -88.1417 },
                            { name: "Pistakee Lake", lat: 42.3792, lng: -88.2037 },
                            { name: "Grass Lake", lat: 42.4634, lng: -88.1412 },
                            { name: "Lake Michigan (Chicago)", lat: 41.8781, lng: -87.6298 },
                            { name: "Delavan Lake", lat: 42.605, lng: -88.6348 },
                            { name: "Lake Koshkonong", lat: 42.8336, lng: -89.0165 },
                        ]}
                        mapCenter = {{
                            lat: 42.2411,
                            lng: -88.3162,
                        }}
                        mapZoom={10}
                        defaultRadius={35}
                    />
                </div>
                <div className={styles.waterbodiesRowFour}>
                    <SendWaterBodyUpdates />
                </div>
            </div>
        </SidebarLayout>
    );
};

export default WaterbodiesCampaign;